import { render, staticRenderFns } from "./accounts-dialog.vue?vue&type=template&id=b9a18ae8&scoped=true&"
import script from "./accounts-dialog.vue?vue&type=script&lang=ts&"
export * from "./accounts-dialog.vue?vue&type=script&lang=ts&"
import style0 from "@/modules/Dashboard/styles/dashboard-dialog.scss?vue&type=style&index=0&id=b9a18ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a18ae8",
  null
  
)

export default component.exports